export enum searchTypesEnum {
  REQUEST = 'FETCH_SEARCH_REQUEST',
  FAILURE_USER = 'FAILURE_SEARCH',
  SET_SEARCH = 'SET_SEARCH',
  RESET_SEARCH = 'RESET_SEARCH',
  RESET_LOADING = 'RESET_LOADING',
}
